export default {
    meta: {
        title: '展位',
        isShowNav: true,
        isEdit: true,
        activeMenu: '/booth',
        crumbs: {
            path: ['/booth'],
            name: ['展位管理'],
        },
    },
};
